module.exports = __webpack_public_path__ + "img/fixed.a2e99ad6.svg";